// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"7d1841f5","496":"7b4d882e"}[chunkId] + ".chunk.js";
};